import dayjs from 'dayjs';

export const getUpdatedMobileDateRange = (currentRange, index, date, fallbackDays = 7) => {
  if (!date) return null;

  const nextRange = Array.isArray(currentRange) && currentRange.length === 2
    ? [...currentRange]
    : [dayjs().subtract(fallbackDays, 'day'), dayjs()];

  nextRange[index] = date;

  if (nextRange[0] && nextRange[1] && nextRange[0].isAfter(nextRange[1])) {
    return [nextRange[1], nextRange[0]];
  }

  return nextRange;
};
